import Headroom from 'headroom.js';

let header = document.getElementById("header");
let options = {
    offset : 0,    // callback when pinned, `this` is headroom object
    onPin: () => {
        // header visible
    },
    onUnpin: () => {
        // header hidden
    },
    onTop: () => {
        // top
    },
    onNotTop: () => {
        // not top
    }
};

const headroom = new Headroom(header, options);
headroom.init();